
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { useEffect, useState } from "react";




export default function DadosConsultaPJ({
  dadosConsultaPJ,
  capitalSocial
}: {
  dadosConsultaPJ: any,
  capitalSocial: string
}) {
  const { t } = useTranslation();
  const [cnaeSecundario, setCnaeSecundario] = useState<string>();
  const [filiais, setFiliais] = useState<string>();
  useEffect(() => {
    if (dadosConsultaPJ.cnaeSecundario) {
      let result = '';
      dadosConsultaPJ.cnaeSecundario.forEach((opcao: string) => {
        if (result.length === 0) {
          result = result.concat(opcao);
        }
        else {
          result = result.concat(', ').concat(opcao);
        }

      })
      setCnaeSecundario(result)
    }
    if (dadosConsultaPJ.filiaisRegiao) {
      let resultFiliais = '';
      dadosConsultaPJ.filiaisRegiao.forEach((opcao: string) => {
        if (resultFiliais.length === 0) {
          resultFiliais = resultFiliais.concat(opcao);
        }
        else {
          resultFiliais = resultFiliais.concat(', ').concat(opcao);
        }

      })
      setFiliais(resultFiliais)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Panel header={t('dadosConsulta')} style={{ width: '98%' }}>

      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('razaoSocial')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.razaoSocial} />
          </div>
        </div>
        <div className="col">
          <div >
            <label className="label-dados">{t('nomeFantasia')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.nomeFantasia ? dadosConsultaPJ.nomeFantasia : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('documento')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.documento} />
          </div>
        </div>
        <div className="col">
          <div >
            <label className="label-dados">{t('situacao')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.situacao ? dadosConsultaPJ.situacao : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('cnae')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.cnae ? dadosConsultaPJ.cnae : 'Não Informado'} />
          </div>
        </div>
        <div className="col">
          <div >
            <label className="label-dados">{t('dataAbertura')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.dataAbertura ? dadosConsultaPJ.dataAbertura : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('fone')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.telefone ? dadosConsultaPJ.telefone : 'Não Informado'} />
          </div>
        </div>
        <div className="col">
          <div >
            <label className="label-dados">{t('email')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.email ? dadosConsultaPJ.email : 'Não Informado'} />
          </div>
        </div>
      </div>

      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('endereco')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.endereco ? dadosConsultaPJ.endereco : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('capitalSocial')}</label>
            <Chip style={{ width: "100%" }} label={capitalSocial ? capitalSocial : 'Não Informado'} />
          </div>
        </div>
      </div>
      {dadosConsultaPJ.endereco && (
        <div className="grid" style={{ marginTop: '0.5rem' }}>
          <div className="col p-fluid">
            <label className="label-dados">Localização no Mapa</label>
            <iframe
              className="no-print"
              title="Mapa do Endereço"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '8px', marginTop: '4px' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0&q=${encodeURIComponent(dadosConsultaPJ.endereco)}`}
            />
            <img
              className="print-only"
              style={{ width: '100%', borderRadius: '8px', display: 'none' }}
              alt={`Mapa do endereço: ${dadosConsultaPJ.endereco}`}
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(dadosConsultaPJ.endereco)}&zoom=15&size=600x300&markers=${encodeURIComponent(dadosConsultaPJ.endereco)}&key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0`}
            />
          </div>
        </div>
      )}
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('nire')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.nire ? dadosConsultaPJ.nire : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('tipo')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.tipo ? dadosConsultaPJ.tipo : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('naturezaJuridica')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.naturezaJuridica ? dadosConsultaPJ.naturezaJuridica : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('porte')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.porte ? dadosConsultaPJ.porte : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('colaboradores')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.quantidadeColaboradores ? dadosConsultaPJ.quantidadeColaboradores : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('filiais')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.quantidadeFiliais ? dadosConsultaPJ.quantidadeFiliais : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('cnae')} Secundário</label>

            <Chip style={{ marginLeft: '0.5rem', width: "100%" }} label={cnaeSecundario ? cnaeSecundario : 'Não Informado'} />

          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('filiaisRegiao')}</label>

            <Chip style={{ marginLeft: '0.5rem', width: "100%" }} label={filiais ? filiais : 'Não Informado'} />

          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div >
            <label className="label-dados">{t('Status Cadastro Positivo')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.cpstatus ? dadosConsultaPJ.cpstatus : 'Não Informado'} />
          </div>
        </div>
      </div>
    </Panel>
  )
}
